import React, { useEffect, useState } from "react";
import { FaEye, FaShieldAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import profilepic from "../../assests/modalpic.png";
import userServices from "../../api/services/userService";
import Loading from "../../components/Loading";

const TopUsers = () => {
  const [activeTab, setActiveTab] = useState("all");
  const [isOpen, setIsOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const [backendPage, setBackendPage] = useState(1); // backend page
  const [total, setTotal] = useState(0); // total users from backend
  const backendLimit = 50; // backend always returns 50 users
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // frontend pagination
  const [frontendPage, setFrontendPage] = useState(1);
  const frontendLimit = 15;

  const navigate = useNavigate();

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setIsLoading(true);
        let result;

        if (activeTab === "all") {
          result = await userServices.fetchAllUsers(backendPage);
        } else if (activeTab === "premium") {
          result = await userServices.fetchAllPremiumUsers(backendPage);
        } else if (activeTab === "completed") {
          result = await userServices.fetchCompletedUsers(backendPage);
        }

        console.log(result);
        const allUsers = result?.users || [];
        const visibleUsers = allUsers.filter(
          (user) =>
            !user.email ||
            !user.email.toLowerCase().endsWith("@naseebimail.com")
        );
        setUsers(visibleUsers);
        setTotal(result?.total || 0);
        setFrontendPage(1); // reset frontend page whenever backend page changes or tab changes
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUsers();
  }, [backendPage, activeTab]);

  const tabs = [
    { key: "all", label: "Recent Users" },
    { key: "premium", label: "Premium Users" },
    { key: "completed", label: "Completed Users" },
  ];

  // frontend slice 15 users
  const paginatedUsers = users.slice(
    (frontendPage - 1) * frontendLimit,
    frontendPage * frontendLimit
  );
  const filteredUsers = paginatedUsers.filter((user) => {
    const fullName = `${user.firstName} ${user.lastName}`.toLowerCase();
    return (
      fullName.includes(searchQuery.toLowerCase()) ||
      (user.email &&
        user.email.toLowerCase().includes(searchQuery.toLowerCase()))
    );
  });
  return (
    <div className="p-4 w-full">
      {isLoading ? (
        <Loading />
      ) : (
        <>
          {/* Tabs */}
          <div className="flex justify-between items-center mb-4">
            <div className="flex gap-4">
              {tabs.map((tab) => (
                <button
                  key={tab.key}
                  onClick={() => {
                    setActiveTab(tab.key);
                    setBackendPage(1);
                  }}
                  className={`px-4 py-2 rounded ${
                    activeTab === tab.key
                      ? "bg-red-500 text-white shadow"
                      : "bg-gray-100 text-gray-700"
                  }`}>
                  {tab.label}
                </button>
              ))}
            </div>

            <input
              type="text"
              placeholder="Search by name or email..."
              className="border px-3 py-2 rounded w-64"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          {/* Table */}
          <div className="overflow-x-auto bg-white shadow rounded-lg">
            <table className="w-full text-left border-collapse">
              <thead className="bg-gray-100">
                <tr>
                  <th className="px-4 py-2">SR. NO</th>
                  <th className="px-4 py-2">First Name</th>
                  <th className="px-4 py-2">Last Name</th>
                  <th className="px-4 py-2">Email</th>
                  <th className="px-4 py-2">Contact Number</th>
                  <th className="px-4 py-2">DOCUMENT STATUS</th>
                  <th className="px-4 py-2">ACTIONS</th>
                </tr>
              </thead>
              <tbody>
                {filteredUsers.length > 0 ? (
                  filteredUsers.map((user, idx) => (
                    <tr key={user.id} className="border-t">
                      <td className="px-4 py-2">
                        {(frontendPage - 1) * frontendLimit + idx + 1}
                      </td>
                      <td className="px-4 py-2 flex items-center gap-2">
                        {user.firstName}
                      </td>
                      <td className="px-4 py-2">{user.lastName}</td>
                      <td className="px-4 py-2">{user.email}</td>
                      <td className="px-4 py-2">{user.contactNo}</td>
                      <td
                        className={`px-4 py-2 font-semibold ${
                          user.document === "Not Uploaded"
                            ? "text-red-500"
                            : "text-green-500"
                        }`}>
                        {user.document || "Not Uploaded"}
                      </td>
                      <td className="px-4 py-2 flex gap-3">
                        <div
                          className="relative group"
                          onClick={() => navigate(`/userdetails/${user.id}`)}>
                          <FaEye className="text-red-500 cursor-pointer" />
                          <span className="absolute bottom-full mb-2 hidden group-hover:block bg-gray-700 text-white text-xs px-2 py-1 rounded">
                            View
                          </span>
                        </div>

                        <div className="relative group">
                          <FaShieldAlt
                            className="text-red-500 cursor-pointer"
                            onClick={() => setIsOpen(true)}
                          />
                          <span className="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 hidden group-hover:block bg-gray-700 text-white text-xs text-center px-2 py-1 rounded w-[135px] z-50">
                            Verify User Profile Pic
                          </span>
                        </div>
                        {isOpen && (
                          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                            <div className="bg-white rounded-lg shadow-lg w-4/3 h-auto p-6 relative">
                              <button
                                className="absolute top-2 right-2 text-gray-500 hover:text-black"
                                onClick={() => setIsOpen(false)}>
                                ✕
                              </button>
                              <h2 className="text-xl font-bold mb-4">
                                Verify User Profile Pic
                              </h2>
                              <div className="w-full h-80">
                                <img src={profilepic} alt="" width={300} />
                              </div>

                              <div className="flex justify-end gap-2">
                                <button
                                  onClick={() => setIsOpen(false)}
                                  className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400">
                                  Cancel
                                </button>
                                <button className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600">
                                  Approve
                                </button>
                                <button className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600">
                                  Reject
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="7"
                      className="text-center py-4 text-gray-500 font-medium">
                      No users found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div className="flex justify-between items-center mt-4 text-sm text-gray-600">
            <span>Rows per page: {frontendLimit}</span>
            <span>
              {(frontendPage - 1) * frontendLimit + 1}–
              {Math.min(frontendPage * frontendLimit, users.length)} of{" "}
              {users.length}
              <button
                className="ml-2 px-2"
                disabled={frontendPage === 1}
                onClick={() => setFrontendPage((prev) => prev - 1)}>
                &lt;
              </button>
              <button
                className="px-2"
                disabled={frontendPage * frontendLimit >= users.length}
                onClick={() => setFrontendPage((prev) => prev + 1)}>
                &gt;
              </button>
            </span>
          </div>
        </>
      )}
    </div>
  );
};

export default TopUsers;
